module.exports = __webpack_public_path__ + "img/Truck-transport.1fd57de.jpg";